// H5 与 PC 使用相同的定点滚动公式；这里的金额只用于展示，不参与派奖。
const states = new Set([1, 2, 3, 4]);
const money = value => {
  if (typeof value !== 'string' || !/^\d{1,16}(?:\.\d{1,4})?$/.test(value)) throw new Error('展示奖池金额无效');
  const [whole, fraction = ''] = value.split('.');
  return BigInt(whole) * 10000n + BigInt(fraction.padEnd(4, '0'));
};

export function displayPoolView(pool, elapsedMilliseconds = 0) {
  if (!pool || !states.has(pool.state) || typeof pool.title !== 'string' || !pool.title.trim()) throw new Error('展示奖池配置无效');
  const { startAt, endAt, serverTime } = pool;
  if (![startAt, endAt, serverTime].every(value => Number.isSafeInteger(value) && value > 0) || endAt <= startAt || !Number.isFinite(elapsedMilliseconds)) throw new Error('展示奖池时间无效');
  const start = money(pool.startAmount), end = money(pool.endAmount);
  if (end < start) throw new Error('展示奖池金额范围无效');
  const now = serverTime + Math.max(0, Math.floor(elapsedMilliseconds));
  const used = BigInt(Math.max(0, Math.min(endAt - startAt, now - startAt)));
  const units = start + (end - start) * used / BigInt(endAt - startAt);
  const cents = units / 100n;
  const state = pool.state === 4 ? 4 : now < startAt ? 2 : now >= endAt ? 3 : 1;
  return {
    state,
    amount: state === 4 ? '—' : `${(cents / 100n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${(cents % 100n).toString().padStart(2, '0')}`,
    label: { 1: '展示金额', 2: '尚未开始', 3: '已结束', 4: '已停用' }[state],
  };
}

export function displayPoolImage(value) {
  if (typeof value !== 'string') return '';
  if (/^\/(?!\/)/.test(value)) return value;
  try {
    const url = new URL(value);
    return /^https?:$/.test(url.protocol) && !url.username && !url.password ? url.href : '';
  } catch { return ''; }
}

export function displayPoolColor(value, fallback = '#1D2129') {
  return typeof value === 'string' && /^#[\da-f]{6}$/i.test(value) ? value : fallback;
}
